const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


/* ============================================================
   ROCKWELL — storefront extras
   Runs on every page. Five jobs:
     1. hide the sale badge (sold-out badges still show)
     2. draw the colour swatch stack on the bottom-right of the card image
     3. auto-cycle the front photo of every colour, with a progress bar
        in the top-right corner that fills over the life of each frame
     4. product page: turn the key-point ticks into scalloped seals that
        take the colour of the currently selected vest
     5. print prices as  ₹399  instead of  Rs. 399.00
   ============================================================ */
(function () {

  /* ---------- shared: the colour table -------------------------------------
     One map, used by the card swatches and by the product-page seals. */
  var SWATCH = {
    black: '#1A1A1A', white: '#FFFFFF', brown: '#6B4F3A', olive: '#5B5F44',
    grey: '#C9C9C6', gray: '#C9C9C6', cream: '#F5EEDF', beige: '#E3D9C6',
    charcoal: '#3A3A3A', navy: '#1F2A44', blue: '#2B5FA8', red: '#C1272D',
    green: '#2E7D4F', maroon: '#6B2233', sand: '#D8C9AE', khaki: '#9A8B6C'
  };
  var probe = document.createElement('span');

  function colourOf(name) {
    var key = (name || '').toLowerCase().trim();
    if (SWATCH[key]) return SWATCH[key];
    // let the browser try the raw name ("Sky Blue" -> nothing, "teal" -> teal)
    probe.style.background = '';
    probe.style.background = key;
    return probe.style.background || '#111111';
  }

  /* Relative luminance, so text on a pale badge flips to black instead of
     vanishing. Handles #rgb, #rrggbb and rgb(r,g,b).
     Returns 0 (treated as dark) if the colour can't be parsed. */
  function luminance(colour) {
    var r, g, b, m, h;
    if (!colour) return 0;
    if (colour.charAt(0) === '#') {
      h = colour.slice(1);
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      if (h.length !== 6) return 0;
      r = parseInt(h.substr(0, 2), 16);
      g = parseInt(h.substr(2, 2), 16);
      b = parseInt(h.substr(4, 2), 16);
    } else {
      m = colour.match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i);
      if (!m) return 0;
      r = +m[1]; g = +m[2]; b = +m[3];
    }
    function ch(c) { c = c / 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    return 0.2126 * ch(r) + 0.7152 * ch(g) + 0.0722 * ch(b);
  }

  var cache = {};
  function productData(url) {
    if (!cache[url]) cache[url] = fetch(url + '.js').then(function (r) { return r.json(); });
    return cache[url];
  }

  /* "https://cdn/.../vest.png?v=1" -> ".../vest_700x.png?v=1" */
  function sized(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2');
  }

  /* ---------- 0. styles injected once ------------------------------------- */
  var STYLE_ID = 'rw-card-style';
  function styleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      /* --- quick add button --- */
      '.card-wrapper .quick-add__submit,',
      '.card-wrapper .quick-add .button{',
      'background:#000 !important;color:#fff !important;',
      'border:1px solid #000 !important;box-shadow:none !important;}',
      '.card-wrapper .quick-add__submit:hover,',
      '.card-wrapper .quick-add .button:hover{',
      'background:#1f1f1f !important;color:#fff !important;border-color:#1f1f1f !important;}',
      '.card-wrapper .quick-add__submit::after,',
      '.card-wrapper .quick-add .button::after{box-shadow:none !important}',
      '.card-wrapper .quick-add__submit .loading__spinner path{fill:#fff}',
      /* --- slideshow progress bar --- */
      '.rw-progress{position:absolute;top:10px;right:10px;z-index:4;',
      'width:44px;height:3px;border-radius:2px;overflow:hidden;',
      'background:rgba(0,0,0,.18);pointer-events:none}',
      '.rw-progress__fill{display:block;width:100%;height:100%;',
      'background:#111;transform:scaleX(0);transform-origin:left center}',
      '@keyframes rw-fill{from{transform:scaleX(0)}to{transform:scaleX(1)}}',
      '@media screen and (max-width:749px){.rw-progress{width:34px;top:8px;right:8px}}',
      '@media (prefers-reduced-motion:reduce){.rw-progress{display:none}}',
      /* --- product page key-point seals ---
         !important because the product section styles these at 18px with an
         ID-prefixed selector, which a plain class rule cannot outrank. */
      '.rp-usp svg{width:22px !important;height:22px !important;',
      'flex:0 0 22px !important;margin-top:0 !important}',
      /* pull the proof pill up towards the price, and ease its colour change */
      '.rp-proof{margin-top:6px !important;',
      'transition:background-color .2s ease,color .2s ease,border-color .2s ease}',
      /* --- slot-machine number in the proof pill ---
         Each digit is a 1em window over a 50-digit reel (0-9 five times), so
         the reel makes four full rotations before landing. Digits are staggered
         so they settle left to right, the last one landing at 5s. Rotations
         scale with duration - stretching a short spin over a long window makes
         it drift rather than spin. */
      '.rw-slots{display:inline-flex;align-items:flex-end}',
      '.rw-slot{display:inline-block;height:1em;line-height:1em;overflow:hidden;',
      'width:.58em;text-align:center}',
      /* the comma must share the digits' exact box, or its taller default
         line box lifts the glyph and it reads as a full stop */
      '.rw-slot-sep{display:inline-block;height:1em;line-height:1em;',
      'font-style:normal;transform:translateY(.05em)}',
      '.rw-reel{display:block;transform:translateY(0);',
      'animation:rw-spin 4400ms cubic-bezier(.25,0,.15,1) var(--t,0ms) both}',
      '.rw-reel>span{display:block;height:1em;line-height:1em}',
      '@keyframes rw-spin{from{transform:translateY(0)}to{transform:translateY(var(--d,0))}}',
      /* --- size finder inside the size guide --- */
      '.rw-fit{padding:22px 22px 6px;font-size:14px;line-height:1.45}',
      '.rw-fit h3{margin:0 0 4px;font-size:19px;letter-spacing:-.01em}',
      '.rw-fit__lead{margin:0 0 18px;opacity:.7;font-size:13px}',
      '.rw-fit__q{margin:0 0 8px;font-weight:600;font-size:13px}',
      '.rw-fit__row{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 18px}',
      /* options are black by default; the chosen one inverts to white, so the
         two states cannot be confused. Border stays 1px in both so nothing
         shifts when it is tapped. */
      '.rw-fit__b{min-width:52px;height:40px;padding:0 14px;border:1px solid #111;',
      'background:#111;color:#fff;font:inherit;font-size:13px;border-radius:3px;cursor:pointer;',
      'transition:background .15s,color .15s}',
      '.rw-fit__b[aria-pressed="true"]{background:#fff;color:#111}',
      '.rw-fit__res{border:1px solid rgba(0,0,0,.14);border-radius:8px;padding:16px;',
      'margin:0 0 18px;background:#F7F6F3}',
      '.rw-fit__res[hidden]{display:none}',
      '.rw-fit__pick{font-size:15px;margin:0 0 6px}',
      '.rw-fit__pick b{font-size:22px;letter-spacing:-.01em}',
      '.rw-fit__why{margin:0 0 12px;font-size:13px;opacity:.75}',
      '.rw-fit__specs{list-style:none;margin:0 0 14px;padding:0;font-size:13px}',
      '.rw-fit__specs li{padding:3px 0;border-bottom:1px solid rgba(0,0,0,.07)}',
      '.rw-fit__specs li:last-child{border-bottom:0}',
      '.rw-fit__go{width:100%;min-height:44px;border:0;border-radius:3px;background:#111;',
      'color:#fff;font:inherit;font-size:13px;letter-spacing:.05em;cursor:pointer}',
      '.rw-fit__table{width:100%;border-collapse:collapse;font-size:13px;margin:0 0 6px}',
      '.rw-fit__table th,.rw-fit__table td{padding:8px 6px;text-align:left;',
      'border-bottom:1px solid rgba(0,0,0,.1)}',
      '.rw-fit__table th{font-size:11px;letter-spacing:.06em;text-transform:uppercase;',
      'color:#111;font-weight:700}',
      '.rw-fit__table tr[data-on="1"] td{background:#F1EFEA;font-weight:600}',
      '.rw-fit__note{margin:14px 0 0;font-size:12px;color:#111;font-weight:600;line-height:1.5}',
      /* on desktop the chart sits beside the numbers instead of below them,
         so the guide reads in one screen rather than two scrolls */
      '.rw-fit__cols{display:grid;grid-template-columns:1fr;gap:18px;align-items:start}',
      '.rw-fit__cols img{max-height:60vh;object-fit:contain;border-radius:6px}',
      '@media(min-width:750px){',
      '.rw-fit__cols{grid-template-columns:minmax(0,1fr) minmax(0,.92fr);gap:26px}',
      '.rw-fit__cols img{max-height:none}}',
      '@media(max-width:749px){.rw-fit{padding:16px 16px 4px}',
      '.rw-fit__b{min-width:46px;height:38px;padding:0 11px}}',
      /* --- links inside the product tabs ---
         Black rather than the theme's blue. The underline has to stay: with
         the colour gone it is the only thing marking the text as clickable. */
      '.rp-panel a{color:#111 !important;text-decoration:underline;',
      'text-underline-offset:3px;text-decoration-thickness:1px}',
      '.rp-panel a:hover{opacity:.65}',
      '.rp-usp svg .rw-seal{transition:fill .2s ease,stroke .2s ease}',
      '.rp-usp svg .rw-tick{transition:stroke .2s ease}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- 1. badges ---------------------------------------------------
     rockwell-custom.css hides every card badge so the sale badge never
     flashes on screen. Sold-out is the one badge worth keeping. */
  function badges(card) {
    var list = card.querySelectorAll('.card__badge .badge');
    for (var i = 0; i < list.length; i++) {
      if (/sold|stock/i.test(list[i].textContent || '')) {
        list[i].parentElement.classList.add('rw-badge-show');
      }
    }
  }

  /* ---------- 2. colour swatches on the card ------------------------------ */
  function swatches(card) {
    var inner = card.querySelector('.card__inner');
    var link = card.querySelector('a[href*="/products/"]');
    if (!inner || !link || inner.querySelector('.rw-swatches')) return;
    inner.setAttribute('data-rw-sw', '1');

    var url = link.getAttribute('href').split('?')[0];
    productData(url).then(function (p) {
      var opt = null;
      (p.options || []).forEach(function (o) {
        var n = (o.name || o) + '';
        if (/colou?r/i.test(n) && o.values) opt = o;
      });
      if (!opt || opt.values.length < 2) return;
      if (inner.querySelector('.rw-swatches')) return;

      var vals = opt.values;
      var show = vals.length > 3 ? vals.slice(0, 3) : vals;

      var box = document.createElement('div');
      box.className = 'rw-swatches';

      show.forEach(function (v) {
        var dot = document.createElement('span');
        dot.className = 'rw-sw';
        dot.style.backgroundColor = colourOf(v);
        // data-colour lets the "Colour swatch images" section drop a real photo
        // on top of the flat colour, per colour name, from the theme editor.
        dot.setAttribute('data-colour', (v || '').toLowerCase().trim());
        dot.setAttribute('aria-hidden', 'true');
        box.appendChild(dot);
      });

      if (vals.length > 3) {
        var count = document.createElement('span');
        count.className = 'rw-sw rw-sw--count';
        count.textContent = vals.length;
        count.setAttribute('aria-hidden', 'true');
        box.appendChild(count);
      }

      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = 'Available in ' + vals.length + ' colours';
      box.appendChild(sr);

      inner.appendChild(box);
      slideshow(card, inner, colourImages(p, vals));
    }).catch(function () { /* a card without a reachable product just gets no swatches */ });
  }

  /* ---------- 3. colour slideshow -----------------------------------------
     Runs on its own, no hover needed, so it also works on phones.
     The image swap is driven by the progress bar's animationend rather than
     a timer, so the bar and the picture can never drift apart.

     To tune:  STEP = milliseconds each colour stays on screen
  --------------------------------------------------------------------------- */
  var STEP = 3000;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function colourImages(p, vals) {
    var media = p.media || [];
    var out = [];
    vals.forEach(function (v) {
      var needle = (v || '').toLowerCase().trim();
      if (!needle) return;
      var pool = media.filter(function (m) {
        return ((m.alt || '') + '').toLowerCase().indexOf(needle) !== -1;
      });
      var front = pool.filter(function (m) {
        return ((m.alt || '') + '').toLowerCase().indexOf('front') !== -1;
      });
      var pick = front[0] || pool[0];
      if (!pick) {
        var vr = (p.variants || []).filter(function (x) {
          return (x.options || []).some(function (o) {
            return (o || '').toLowerCase().trim() === needle;
          });
        })[0];
        if (vr && vr.featured_image) pick = vr.featured_image;
      }
      if (pick && pick.src) out.push({ colour: needle, src: sized(pick.src, 700) });
    });
    return out;
  }

  function slideshow(card, inner, imgs) {
    if (!imgs.length) return;
    var stage = card.querySelector('.card__media') || inner;
    if (!stage || stage.querySelector('.rw-hoverimg')) return;

    var layer = document.createElement('img');
    layer.className = 'rw-hoverimg';
    layer.setAttribute('alt', '');
    layer.setAttribute('aria-hidden', 'true');
    stage.appendChild(layer);

    var idx = 0, warmed = false, running = false;

    var bar = null, fill = null;
    if (imgs.length > 1 && !REDUCED) {
      bar = document.createElement('div');
      bar.className = 'rw-progress';
      bar.setAttribute('aria-hidden', 'true');
      fill = document.createElement('span');
      fill.className = 'rw-progress__fill';
      bar.appendChild(fill);
      stage.appendChild(bar);
    }

    function warm() {
      if (warmed) return;
      warmed = true;
      imgs.forEach(function (o) { var i = new Image(); i.src = o.src; });
    }

    function mark(colour) {
      var dots = card.querySelectorAll('.rw-sw');
      for (var i = 0; i < dots.length; i++) {
        var c = dots[i].getAttribute('data-colour');
        dots[i].classList.toggle('rw-sw--on', !!colour && c === colour);
      }
    }

    function show(i) {
      idx = i;
      layer.src = imgs[i].src;
      layer.classList.add('rw-on');
      mark(imgs[i].colour);
    }

    /* Re-running the same animation needs a reflow between the two writes,
       otherwise the browser coalesces them and nothing restarts. */
    function restart() {
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = 'rw-fill ' + STEP + 'ms linear forwards';
      fill.style.animationPlayState = 'running';
    }

    if (fill) {
      fill.addEventListener('animationend', function () {
        show((idx + 1) % imgs.length);
        restart();
      });
    }

    function start() { if (running || !fill) return; running = true; restart(); }
    function resume() { if (!fill) return; if (!running) { start(); return; } fill.style.animationPlayState = 'running'; }
    function pause() { if (!fill) return; fill.style.animationPlayState = 'paused'; }

    warm();
    show(0);

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) resume(); else pause();
        }
      }, { threshold: 0.25 }).observe(card);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else resume();
    });
    window.addEventListener('pagehide', pause);
  }

  /* ---------- 4. product page: key-point seals -----------------------------
     The product section renders each key point with a small circle + tick.
     Here they are redrawn at a consistent size and weight: solid black
     circle, white tick, on every colour. Deliberately fixed rather than
     following the selected vest colour - a pale seal on a white page
     disappears, and a mark that changes under the shopper reads as a glitch.

     To tune:  RADIUS = circle size inside the 20x20 viewBox
               WEIGHT = thickness of the tick
  --------------------------------------------------------------------------- */
  var RADIUS = 9.1;
  var WEIGHT = 1.7;
  var TICK = 'M6.4 10.2l2.4 2.4 4.9-5.1';

  function seals() {
    var svgs = document.querySelectorAll('.rp-usp svg');
    if (!svgs.length) return;
    for (var i = 0; i < svgs.length; i++) {
      if (svgs[i].getAttribute('data-rw-seal')) continue;
      svgs[i].setAttribute('data-rw-seal', '1');
      svgs[i].setAttribute('viewBox', '0 0 20 20');
      svgs[i].innerHTML =
        '<circle class="rw-seal" cx="10" cy="10" r="' + RADIUS + '" fill="#111111"/>' +
        '<path class="rw-tick" d="' + TICK + '" fill="none" stroke="#FFFFFF"' +
        ' stroke-width="' + WEIGHT + '" stroke-linecap="round" stroke-linejoin="round"/>';
    }
  }

  /* ---------- 4b. recolour to the selected vest ----------------------------
     Both the proof pill and the key-point seals take the colour of whichever
     vest is selected. Anything pale flips its tick/text to black and picks up
     a dark outline, so nothing disappears against a near-white page. One
     threshold drives both effects, so a colour added later works out its own
     contrast instead of rendering white-on-white until someone notices.
  --------------------------------------------------------------------------- */
  function paintProof() {
    var badge = document.querySelector('.rp-proof');
    var seals = document.querySelectorAll('.rp-usp svg .rw-seal');
    if (!badge && !seals.length) return;

    var sw = document.querySelector('.rp-swatches [role="radio"][aria-checked="true"]') ||
             document.querySelector('.rp-sw[aria-checked="true"]');
    var name = sw ? (sw.getAttribute('data-val') || sw.getAttribute('aria-label') || '') : '';
    var hex = colourOf(name);
    var pale = luminance(hex) > 0.45;
    var ink = pale ? '#111111' : '#FFFFFF';
    var line = pale ? '#111111' : hex;
    var i;

    /* -- the proof pill -- */
    if (badge) {
      badge.style.backgroundColor = hex;
      badge.style.color = ink;
      badge.style.borderColor = line;

      // the tick inverts with the pill: dot in the text colour, mark in the
      // badge colour, so it reads at every combination
      var dot = badge.querySelector('svg circle');
      var mark = badge.querySelector('svg path');
      if (dot && dot.getAttribute('fill') !== ink) dot.setAttribute('fill', ink);
      if (mark && mark.getAttribute('stroke') !== hex) mark.setAttribute('stroke', hex);
    }

    /* -- the key-point seals -- */
    for (i = 0; i < seals.length; i++) {
      if (seals[i].getAttribute('fill') !== hex) seals[i].setAttribute('fill', hex);
      if (seals[i].getAttribute('stroke') !== (pale ? '#111111' : 'none')) {
        seals[i].setAttribute('stroke', pale ? '#111111' : 'none');
      }
    }
    var ticks = document.querySelectorAll('.rp-usp svg .rw-tick');
    for (i = 0; i < ticks.length; i++) {
      if (ticks[i].getAttribute('stroke') !== ink) ticks[i].setAttribute('stroke', ink);
    }
  }

  /* ---------- 4b-ii. slot-machine count in the proof pill ------------------
     The first number in the badge is swapped for a row of spinning digit
     reels. Runs once, when the badge first scrolls into view - a counter
     that has already finished before anyone looks at it is wasted.

     The original text is kept for screen readers; only the reels are hidden
     from them, since a column of ten digits reads as nonsense.
  --------------------------------------------------------------------------- */
  function slot() {
    var span = document.querySelector('.rp-proof span');
    if (!span || span.getAttribute('data-rw-slot')) return;

    var text = span.textContent || '';
    var m = text.match(/\d[\d,]*/);
    if (!m) return;
    span.setAttribute('data-rw-slot', '1');
    if (REDUCED) return;                 // leave the plain number in place

    var num = m[0];
    var before = text.slice(0, m.index);
    var after = text.slice(m.index + num.length);

    var reels = document.createElement('span');
    reels.className = 'rw-slots';
    reels.setAttribute('aria-hidden', 'true');

    var delay = 0, i, d, cell, track, k;
    for (i = 0; i < num.length; i++) {
      d = num.charAt(i);
      if (d < '0' || d > '9') {          // a comma: keep it still
        var sep = document.createElement('i');
        sep.className = 'rw-slot-sep';
        sep.textContent = d;
        reels.appendChild(sep);
        continue;
      }
      cell = document.createElement('span');
      cell.className = 'rw-slot';
      track = document.createElement('span');
      track.className = 'rw-reel';
      // four full rotations (40) plus the landing digit, as a share of the
      // reel's own 50-digit height
      track.style.setProperty('--d', '-' + ((40 + Number(d)) * (100 / 50)).toFixed(4) + '%');
      track.style.setProperty('--t', delay + 'ms');
      for (k = 0; k < 50; k++) {
        var digit = document.createElement('span');
        digit.textContent = String(k % 10);
        track.appendChild(digit);
      }
      cell.appendChild(track);
      reels.appendChild(cell);
      delay += 150;
    }

    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = text;

    span.textContent = '';
    if (before) span.appendChild(document.createTextNode(before));
    span.appendChild(reels);
    if (after) span.appendChild(document.createTextNode(after));
    span.appendChild(sr);
  }

  function slotWhenSeen() {
    var badge = document.querySelector('.rp-proof');
    if (!badge || badge.getAttribute('data-rw-slotwatch')) return;
    badge.setAttribute('data-rw-slotwatch', '1');
    if (!window.IntersectionObserver) { slot(); return; }

    /* On a phone the badge first appears right at the bottom edge of the
       screen, where nobody is looking - the reels would finish rolling before
       it reached a readable position. Shrinking the observed area up from the
       bottom means the badge has to be properly on screen before the animation
       starts, which in practice is the second scroll.

       Position, not a scroll counter: one flick of a thumb fires dozens of
       scroll events and a slow drag fires none, so counting them is not a
       reliable way to say "the customer can now see this". */
    var narrow = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      slot();
    }, {
      threshold: 1,
      rootMargin: narrow ? '0px 0px -38% 0px' : '0px'
    });
    io.observe(badge);
  }

  /* ---------- 4b-iii. size guide lightbox ----------------------------------
     Opens the size chart image over the page. Closes on the X, on the
     backdrop, and on Escape - all three, because a shopper who cannot get
     out of a modal abandons the page, not just the modal.
  --------------------------------------------------------------------------- */
  function sgOpen() {
    var m = document.querySelector('.rp-sgmodal');
    if (!m) return;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var x = m.querySelector('.rp-sgclose');
    if (x) x.focus();
  }

  function sgClose() {
    var m = document.querySelector('.rp-sgmodal');
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-rw-sizeguide]')) { e.preventDefault(); sgOpen(); return; }
    if (e.target.closest('.rp-sgclose')) { sgClose(); return; }
    // a click on the backdrop, but not on the panel itself
    if (e.target.closest('.rp-sgmodal') && !e.target.closest('.rp-sgbox')) sgClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) sgClose();
  });

  /* ---------- 4b-iv. size finder --------------------------------------------
     Two taps instead of a tape measure. Most men shopping on a phone do not
     have one, and a guessed measurement produces a confidently wrong answer -
     worse than no finder at all. Anchoring on a garment they already own is
     the reliable input.

     Ribbed cotton with elastane is cut close, so the recommendation is one
     size down from a standard tee for a body-hugging fit, and level with it
     for regular. The shopper never has to know that rule; the finder applies
     it for them.

     The table comes from the theme editor, so the numbers stay editable and
     the logic keeps working if a size is ever added or removed.
  --------------------------------------------------------------------------- */
  function fitRows(modal) {
    var raw = modal.getAttribute('data-sizes') || '';
    return raw.split(/[\n;]+/).map(function (line) {
      var p = line.split('|');
      if (p.length < 2) return null;
      return {
        size: (p[0] || '').trim(),
        flat: (p[1] || '').trim(),
        len: (p[2] || '').trim(),
        fits: (p[3] || '').trim()
      };
    }).filter(function (r) { return r && r.size; });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function sizeFinder() {
    var modal = document.querySelector('.rp-sgmodal');
    if (!modal || modal.getAttribute('data-rw-fit')) return;
    var box = modal.querySelector('.rp-sgbox');
    if (!box) return;

    var rows = fitRows(modal);
    if (rows.length < 2) return;          // no table set: chart image only
    modal.setAttribute('data-rw-fit', '1');

    var tees = (modal.getAttribute('data-tees') || 'S, M, L, XL, XXL')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var wrap = el('div', 'rw-fit');
    wrap.appendChild(el('h3', null, 'Find your size'));
    wrap.appendChild(el('p', 'rw-fit__lead',
      'Ribbed cotton is cut close. Tell us your t-shirt size and we will tell you which size to take.'));

    wrap.appendChild(el('p', 'rw-fit__q', 'Select the size you usually wear in a t-shirt'));
    var teeRow = el('div', 'rw-fit__row');
    tees.forEach(function (t, i) {
      var b = el('button', 'rw-fit__b', t);
      b.type = 'button';
      b.setAttribute('data-tee', i);
      b.setAttribute('aria-pressed', 'false');
      teeRow.appendChild(b);
    });
    wrap.appendChild(teeRow);

    /* fit question removed 2026-09-18 - the choice stalled customers; regular is the default */
    var fitRow = el('div', 'rw-fit__row');
    [['snug', 'Body hugging'], ['regular', 'Regular']].forEach(function (f) {
      var b = el('button', 'rw-fit__b', f[1]);
      b.type = 'button';
      b.setAttribute('data-fit', f[0]);
      b.setAttribute('aria-pressed', 'false');
      fitRow.appendChild(b);
    });
    /* fitRow intentionally not appended - its buttons and handlers stay in memory */

    var res = el('div', 'rw-fit__res');
    res.hidden = true;
    wrap.appendChild(res);

    /* the full table, as real text rather than only a picture - readable on a
       phone, selectable, and visible to search engines */
    var table = el('table', 'rw-fit__table');
    var thead = el('thead');
    var htr = el('tr');
    /* flat chest is parsed but not shown - it is a manufacturing figure, and
       putting it beside "fits chest" invites the shopper to order off the
       wrong number. Kept in the setting so the column can come back. */
    ['Size', 'Length', 'Fits chest'].forEach(function (h) {
      htr.appendChild(el('th', null, h));
    });
    thead.appendChild(htr);
    table.appendChild(thead);
    var tbody = el('tbody');
    rows.forEach(function (r) {
      var tr = el('tr');
      tr.setAttribute('data-size', r.size);
      tr.appendChild(el('td', null, r.size));
      tr.appendChild(el('td', null, r.len ? r.len + '"' : '—'));
      tr.appendChild(el('td', null, r.fits ? r.fits + '"' : '—'));
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    /* table and chart share a row on desktop, stack on mobile */
    var cols = el('div', 'rw-fit__cols');
    cols.appendChild(table);
    wrap.appendChild(cols);

    wrap.appendChild(el('p', 'rw-fit__note',
      'Fits chest is your own chest measurement, not the garment’s. What we suggest is a guide, ' +
      'based on how this vest is cut — you know your own fit best, so take the size you are most ' +
      'comfortable in.'));

    // sits above the chart diagram, below the close button
    var img = box.querySelector('img');
    if (img) box.insertBefore(wrap, img); else box.appendChild(wrap);
    // and the chart moves in beside the table
    if (img) cols.appendChild(img);

    /* -- state -- */
    var state = { tee: null, fit: 'regular' };

    function press(row, attr, val) {
      var bs = row.querySelectorAll('.rw-fit__b');
      for (var i = 0; i < bs.length; i++) {
        bs[i].setAttribute('aria-pressed', bs[i].getAttribute(attr) === String(val) ? 'true' : 'false');
      }
    }

    function paint() {
      if (state.tee === null || state.fit === null) return;
      var idx = state.fit === 'regular'
        ? Math.min(state.tee + 1, rows.length - 1)
        : Math.min(state.tee, rows.length - 1);
      var r = rows[idx];
      var capped = state.fit === 'regular' && state.tee + 1 > rows.length - 1;

      res.textContent = '';
      var pick = el('div', 'rw-fit__pick');
      pick.appendChild(document.createTextNode('We recommend '));
      pick.appendChild(el('b', null, r.size));
      res.appendChild(pick);

      res.appendChild(el('p', 'rw-fit__why', capped
        ? r.size + ' is our largest size. If you want room to spare, this is the one.'
        : (state.fit === 'snug'
          ? 'One size down from your usual tee — ribbed cotton stretches to sit close.'
          : 'The same as your usual tee, which leaves a little room in a ribbed cut.')));

      var ul = el('ul', 'rw-fit__specs');
      if (r.len) ul.appendChild(el('li', null, 'Length ' + r.len + '"'));
      if (r.fits) ul.appendChild(el('li', null, 'Fits a ' + r.fits + '" chest'));
      res.appendChild(ul);

      var go = el('button', 'rw-fit__go', 'Select size ' + r.size);
      go.type = 'button';
      go.setAttribute('data-rw-pick', r.size);
      res.appendChild(go);

      res.hidden = false;

      var trs = table.querySelectorAll('tbody tr');
      for (var i = 0; i < trs.length; i++) {
        trs[i].setAttribute('data-on', trs[i].getAttribute('data-size') === r.size ? '1' : '0');
      }
    }

    teeRow.addEventListener('click', function (e) {
      var b = e.target.closest('.rw-fit__b');
      if (!b) return;
      state.tee = Number(b.getAttribute('data-tee'));
      press(teeRow, 'data-tee', state.tee);
      paint();
    });

    fitRow.addEventListener('click', function (e) {
      var b = e.target.closest('.rw-fit__b');
      if (!b) return;
      state.fit = b.getAttribute('data-fit');
      press(fitRow, 'data-fit', state.fit);
      paint();
    });

    /* picking the size closes the guide and selects it on the page, so the
       shopper does not have to remember the answer and find the button */
    res.addEventListener('click', function (e) {
      var g = e.target.closest('[data-rw-pick]');
      if (!g) return;
      var want = g.getAttribute('data-rw-pick');
      var btns = document.querySelectorAll('.rp-size');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('data-val') === want && !btns[i].disabled) {
          btns[i].click();
          break;
        }
      }
      sgClose();
    });
  }

  /* ---------- 4c. A+ slideshow beside the tabs -----------------------------
     Each A+ image is a section block tagged with a colour. Selecting a vest
     colour narrows the set to that colour's images and plays them on a beat.
     A colour with no images of its own falls back to the whole set rather
     than showing an empty frame.

     Like the card slideshow, the swap is driven by the progress bar's
     animationend rather than a timer, so the bar and the picture cannot
     drift apart and pausing is one property change.

     To tune:  AP_STEP = milliseconds each image stays on screen
  --------------------------------------------------------------------------- */
  var AP_STEP = 3000;
  var ap = null;

  function currentColour() {
    var sw = document.querySelector('.rp-swatches [role="radio"][aria-checked="true"]') ||
             document.querySelector('.rp-sw[aria-checked="true"]');
    return sw ? (sw.getAttribute('data-val') || sw.getAttribute('aria-label') || '') : '';
  }

  /* Slides sit off-frame to the RIGHT by default. The outgoing image exits
     LEFT, the incoming one enters from the right. An image parked on the
     left has to be snapped back to the right before its next turn, with the
     transition switched off - otherwise it flies across the frame.

     instant = true snaps rather than slides; used when the shopper clicks a
     swatch, so the colour change feels immediate rather than animated. */
  function apPaint(instant) {
    var all = ap.frame.querySelectorAll('.rp-ap');
    var next = ap.list[ap.i];
    var i, el;

    for (i = 0; i < all.length; i++) {
      el = all[i];
      if (el === next) continue;
      if (el.classList.contains('rp-on')) {
        el.classList.remove('rp-on');
        if (instant) { apSnapRight(el); } else { el.classList.add('rp-out'); }
      } else if (el.classList.contains('rp-out')) {
        apSnapRight(el);
      }
    }

    if (!next) return;
    if (next.classList.contains('rp-on')) return;
    apSnapRight(next);
    if (instant) {
      next.classList.add('rp-snap');
      next.classList.add('rp-on');
      void next.offsetWidth;
      next.classList.remove('rp-snap');
    } else {
      next.classList.add('rp-on');
    }
  }

  /* Park an image off-frame right with no visible movement. */
  function apSnapRight(el) {
    el.classList.add('rp-snap');
    el.classList.remove('rp-out');
    el.classList.remove('rp-on');
    void el.offsetWidth;
    el.classList.remove('rp-snap');
    void el.offsetWidth;
  }

  function apStop() {
    if (!ap || !ap.fill) return;
    ap.running = false;
    ap.fill.style.animation = 'none';
    if (ap.bar) ap.bar.classList.remove('rp-live');
  }

  function apRun() {
    if (!ap.fill || ap.list.length < 2 || REDUCED) { apStop(); return; }
    ap.running = true;
    if (ap.bar) ap.bar.classList.add('rp-live');
    // a reflow between the two writes, or the browser coalesces them and
    // the animation never restarts
    ap.fill.style.animation = 'none';
    void ap.fill.offsetWidth;
    ap.fill.style.animation = 'rp-apfill ' + AP_STEP + 'ms linear forwards';
    ap.fill.style.animationPlayState = ap.visible ? 'running' : 'paused';
  }

  function apPause() { if (ap && ap.fill && ap.running) ap.fill.style.animationPlayState = 'paused'; }
  function apResume() { if (ap && ap.fill && ap.running) ap.fill.style.animationPlayState = 'running'; }

  function apSelect() {
    if (!ap) return;
    var want = currentColour().toLowerCase().trim();
    var all = ap.frame.querySelectorAll('.rp-ap');
    var list = [], i;
    for (i = 0; i < all.length; i++) {
      if ((all[i].getAttribute('data-colour') || '') === want) list.push(all[i]);
    }
    if (!list.length) { for (i = 0; i < all.length; i++) list.push(all[i]); }
    ap.list = list;
    ap.i = 0;
    apPaint(true);
    if (list.length > 1) apRun(); else apStop();
  }

  function aplus() {
    var frame = document.querySelector('[data-rp-aplus]');
    // no A+ blocks added yet: the single fallback image renders as before
    if (!frame || !frame.querySelector('.rp-ap')) return;
    if (ap && ap.frame === frame) { return; }

    var bar = frame.querySelector('.rp-apbar');
    ap = {
      frame: frame,
      bar: bar,
      fill: bar ? bar.querySelector('span') : null,
      list: [], i: 0, running: false, visible: true
    };

    if (ap.fill) {
      ap.fill.addEventListener('animationend', function () {
        if (ap.list.length < 2) return;
        ap.i = (ap.i + 1) % ap.list.length;
        apPaint();
        apRun();
      });
    }

    // a frame scrolled off screen should not keep ticking
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        ap.visible = entries[0].isIntersecting;
        if (ap.visible) apResume(); else apPause();
      }, { threshold: 0.2 }).observe(frame);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) apPause(); else apResume();
    });
    window.addEventListener('pagehide', apPause);

    apSelect();
  }

  /* The product section's script is an IIFE and dispatches no event, so the
     click is the only hook. Deferred a tick so the theme's own handler has
     already moved aria-checked. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.rp-sw')) {
      setTimeout(function () { paintProof(); apSelect(); }, 0);
    }
  });

  /* ---------- 5. rupee sign -----------------------------------------------
     The store's currency format is still "Rs. {{amount}}". This rewrites the
     visible text only. Change Settings > Store details > Store currency >
     Change formatting to fix it properly, including cart and checkout. */
  var PRICE_SEL = '.price, .price-item, .rp-price, .rp-was, .rp-barprice,' +
                  '.rp-trust, .totals, .cart-item__price-wrapper, .cart-drawer__footer,' +
                  '.product__info-container, .card-information';

  function rupee(root) {
    var els = (root || document).querySelectorAll(PRICE_SEL);
    for (var i = 0; i < els.length; i++) {
      var walker = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (t.indexOf('Rs.') === -1 && !/\d\.00\b/.test(t)) continue;
        var v = t.replace(/Rs\.\s*/g, '₹').replace(/(\d)\.00\b/g, '$1');
        if (v !== t) node.nodeValue = v;
      }
    }
  }

  /* ---------- run ---------------------------------------------------------- */
  function run() {
    styleOnce();
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      badges(cards[i]);
      if (!cards[i].querySelector('[data-rw-sw]')) swatches(cards[i]);
    }
    seals();
    paintProof();
    slotWhenSeen();
    sizeFinder();
    aplus();
    rupee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);

  // Cards and prices can arrive later - collection filters, quick-add, cart drawer.
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
